import { RetireKbn, YesOrNoFlug } from "../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

// 退職者本人
const retireeStepper = [
  "退職者確認",
  "請求者の確認",
  "請求者情報の登録",
  "振込先金融機関の登録",
  "本人確認の書類の添付",
  "退職所得の受給に関する申告書の登録",
  "源泉徴収票の確認",
  "申告書兼退職所得申告書の作成",
  "退職所得情報登録",
  "登録内容の確認",
  "機構へ提出",
];

// 相続人
const heirStepper = [
  "退職者確認",
  "請求者の確認",
  "請求者情報の登録",
  "振込先金融機関の登録",
  "添付書類の登録",
  "本人確認の書類の添付",
  "退職所得の受給に関する申告書の登録",
  "源泉徴収票の確認",
  "申告書兼退職所得申告書の作成",
  "退職所得情報登録",
  "登録内容の確認",
  "機構へ提出",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "lineTitle",
    lineTitle:
      "A欄　このA欄には、死亡による遺族請求を除き、すべての人が記載してください。",
  },
  {
    keyword: "retireeName",
    type: "contractorAndNumber",
    contractorName: "退職者名",
    showLine: false,
  },
  {
    title: "①退職手当等の支払いを受けることになった年月日",
    keyword: "paymentConfirmDate",
    type: "date",
    requiredIcon: true,
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
  },
  {
    title: "②退職区分等",
    keyword: "retireKbn",
    type: "radio",
    radioPropsList: TkGetCodeList(RetireKbn),
    requiredIcon: true,
  },
  {
    title: "生活扶助の有無",
    keyword: "livingAssistanceFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    requiredIcon: true,
  },
  {
    title: "③この申告書の提出先から受ける退職手当等の勤続期間",
    keyword: "areaANo3",
    type: "durationPicker",
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
    round: "floorAdd",
    requiredIcon: true,
  },
  {
    keyword: "info",
    type: "lineTitle",
    lineTitle:
      "B欄　あなたが本年中に他にも退職手当金の支払いを受けたことがある場合には入力してください。",
  },
  {
    title: "他の退職金の支払いの有無",
    keyword: "areaBInputCheck",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
  },
  {
    title: "④本年中に支払いを受けた他の退職手当等についての勤続期間",
    keyword: "currentYearLos",
    type: "durationPicker",
    showYears: false,
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
    showLine: false,
  },
  {
    title: "⑤　③と④の通算勤続期間",
    keyword: "areaBNo5",
    type: "durationPicker",
    start: { disabled: true },
    end: { disabled: true },
    round: "floorAdd",
    disabled: true,
    showLine: false,
  },
  {
    keyword: "info",
    type: "lineTitle",
    lineTitle:
      "C欄　あなたが前年以前４年内（その年の確定拠出年金法に基づく老齢給付金として支給される一時金の支払いを受ける場合には、１９年）退職手当等の支払いを受けたことがある場合にはこのC欄に記載してください。",
  },
  {
    title: "他の退職金の支払いの有無",
    keyword: "areaCInputCheck",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
  },
  {
    title: "⑥前年以前４年以内に支払いを受けた他の退職手当等についての勤続期間",
    keyword: "past4yearsLos",
    type: "durationPicker",
    showYears: false,
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
    showLine: false,
  },
  {
    title: "⑦　③又は⑤の勤続期間のうち、⑥の勤続期間と重複している期間",
    keyword: "areaCNo7",
    type: "durationPicker",
    start: { disabled: true },
    end: { disabled: true },
    showYears: false,
    showLine: false,
  },
  {
    keyword: "info",
    type: "lineTitle",
    lineTitle:
      "D欄　A欄またはB欄の退職手当等についての勤続期間のうちに、前に支払いを受けた退職手当等についての勤続期間の全部又は一部が通算されている場合にはその通算された勤続期間について、このD欄に記載してください。",
  },
  {
    title: "通算の有無",
    keyword: "areaDInputCheck",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
  },
  {
    title:
      "⑧Aの退職手当等についての勤続期間（③）に通算された前の退職手当等についての勤続期間",
    keyword: "areaDNo8",
    type: "durationPicker",
    showYears: false,
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
    showLine: false,
  },
  {
    title:
      "⑨Bの退職手当等についての勤続期間（④）に通算された前の退職手当等についての勤続期間",
    keyword: "areaDNo9",
    type: "durationPicker",
    showYears: false,
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
    showLine: false,
  },
  {
    title: "⑩　③又は⑤の勤続期間のうち、⑧又は⑨の勤続期間だけからなる部分の期間",
    keyword: "areaDNo10",
    type: "durationPicker",
    showYears: false,
    start: { disabled: true },
    end: { disabled: true },
    showLine: false,
  },
  {
    title: "⑪　⑦と⑩の通算期間",
    keyword: "areaDNo11",
    type: "durationPicker",
    showYears: false,
    start: { disabled: true },
    end: { disabled: true },
    showLine: false,
  },
  {
    keyword: "info",
    type: "lineTitle",
    lineTitle:
      "E欄　B欄又はC欄の退職手当等がある場合には、このE欄にも記載してください。",
  },
  {
    title: "B欄又はC欄の退職手当等の有無",
    keyword: "areaEInputCheck",
    type: "radio",
    radioPropsList: TkGetCodeList(YesOrNoFlug),
    disabled: true,
  },
  {
    title: "【区分B】退職手当等の支払いを受けることとなった年月日",
    keyword: "currentYearPaymentDecisionDate",
    type: "date",
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
    showLine: false,
  },
  {
    title: "【区分B】収入金額",
    keyword: "currentYearRetirementAllowanceAmt",
    type: "amount",
    inputProps: { maxLength: 9 },
    showLine: false,
  },
  {
    title: "【区分B】源泉徴収額",
    keyword: "currentYearWithholdingAmt",
    type: "amount",
    inputProps: { maxLength: 9 },
    showLine: false,
  },
  {
    title: "【区分B】特別徴収税額（市町村民税）",
    keyword: "currentYearScCityAmt",
    type: "amount",
    inputProps: { maxLength: 9 },
    showLine: false,
  },
  {
    title: "【区分B】特別徴収税額（都道府県民税）",
    keyword: "currentYearScPrefectureAmt",
    type: "amount",
    inputProps: { maxLength: 9 },
    showLine: false,
  },
  {
    title: "【区分B】支払いを受けた年月日",
    keyword: "currentYearGetPaidDate",
    type: "date",
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
    showLine: false,
  },
  {
    title: "【区分B】退職の区分",
    keyword: "currentYearRetirementKbn",
    type: "radio",
    radioPropsList: TkGetCodeList(RetireKbn),
    showLine: false,
  },
  {
    title: "【区分B】支払者の所在地（住所）",
    keyword: "currentYearPayerAddress",
    type: "locationGroup",
    showLine: false,
  },
  {
    title: "【区分B】支払者の名称（氏名）",
    keyword: "currentYearPayerName",
    type: "label",
    showLine: false,
  },
  {
    title: "【区分C】退職手当等の支払いを受けることとなった年月日",
    keyword: "past4yearsPaymentDecisionDate",
    type: "date",
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
    showLine: false,
  },
  {
    title: "【区分C】収入金額",
    keyword: "past4yearsRetirementAllowanceAmt",
    type: "amount",
    inputProps: { maxLength: 9 },
    showLine: false,
  },
  {
    title: "【区分C】源泉徴収額",
    keyword: "past4yearsWithholdingAmt",
    type: "amount",
    inputProps: { maxLength: 9 },
    showLine: false,
  },
  {
    title: "【区分C】特別徴収税額（市町村民税）",
    keyword: "past4yearsScCityAmt",
    type: "amount",
    inputProps: { maxLength: 9 },
    showLine: false,
  },
  {
    title: "【区分C】特別徴収税額（都道府県民税）",
    keyword: "past4yearsScPrefectureAmt",
    type: "amount",
    inputProps: { maxLength: 9 },
    showLine: false,
  },
  {
    title: "【区分C】支払いを受けた年月日",
    keyword: "past4yearsGetPaidDate",
    type: "date",
    maxDate: new Date("2099/12/31"),
    minDate: new Date("1900/1/1"),
    showLine: false,
  },
  {
    title: "【区分C】退職の区分",
    keyword: "past4yearsRetirementKbn",
    type: "radio",
    radioPropsList: TkGetCodeList(RetireKbn),
    showLine: false,
  },
  {
    title: "【区分C】支払者の所在地（住所）",
    keyword: "past4yearsPayerAddress",
    type: "locationGroup",
    showLine: false,
  },
  {
    title: "【区分C】支払者の名称（氏名）",
    keyword: "past4yearsPayerName",
    type: "label",
    showLine: false,
  },
];

const commonSchema = {
  paymentConfirmDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  retireKbn: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  livingAssistanceFlg: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  areaANo3: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  areaBInputCheck: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  areaCInputCheck: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  areaDInputCheck: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

const areaBSchema = {
  currentYearLos: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  currentYearPaymentDecisionDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  currentYearRetirementAllowanceAmt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  currentYearWithholdingAmt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  currentYearScCityAmt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  currentYearScPrefectureAmt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  currentYearGetPaidDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  currentYearRetirementKbn: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  currentYearPayerAddress: {
    validate: (data: any) => {
      let error = {
        prefectures: "",
        city: "",
        address: "",
      };

      error = {
        prefectures: !data?.prefectures
          ? TkPropertyMessageGet("TKMSG_SCR0044E")
          : "",
        city: !data?.city
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : // eslint-disable-next-line no-control-regex
          !data.city?.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]*$/)
          ? TkPropertyMessageGet("TKMSG_SCR0061E")
          : data.city?.length > 20
          ? TkPropertyMessageGet("TKMSG_SCR0046E", "20")
          : "",
        address: !data?.address
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : // eslint-disable-next-line no-control-regex
          !data.address?.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]*$/)
          ? TkPropertyMessageGet("TKMSG_SCR0061E")
          : data.address?.length > 85
          ? TkPropertyMessageGet("TKMSG_SCR0046E", "85")
          : "",
      };

      if (error.prefectures || error.city || error.address) {
        return JSON.stringify(error);
      }
    },
  },
  currentYearPayerName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
};

const areaCSchema = {
  past4yearsLos: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  past4yearsPaymentDecisionDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  past4yearsRetirementAllowanceAmt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  past4yearsWithholdingAmt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  past4yearsScCityAmt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  past4yearsScPrefectureAmt: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "999,999,999"),
    },
  },
  past4yearsGetPaidDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  past4yearsRetirementKbn: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  past4yearsPayerAddress: {
    validate: (data: any) => {
      let error = {
        prefectures: "",
        city: "",
        address: "",
      };

      error = {
        prefectures: !data?.prefectures
          ? TkPropertyMessageGet("TKMSG_SCR0044E")
          : "",
        city: !data?.city
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : // eslint-disable-next-line no-control-regex
          !data.city?.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]*$/)
          ? TkPropertyMessageGet("TKMSG_SCR0061E")
          : data.city?.length > 20
          ? TkPropertyMessageGet("TKMSG_SCR0046E", "20")
          : "",
        address: !data?.address
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : // eslint-disable-next-line no-control-regex
          !data.address?.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]*$/)
          ? TkPropertyMessageGet("TKMSG_SCR0061E")
          : data.address?.length > 85
          ? TkPropertyMessageGet("TKMSG_SCR0046E", "85")
          : "",
      };

      if (error.prefectures || error.city || error.address) {
        return JSON.stringify(error);
      }
    },
  },
  past4yearsPayerName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "48"),
    },
  },
};

const areaDSchema = {
  areaDNo8: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  areaDNo9: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
};

export {
  retireeStepper,
  heirStepper,
  fakeTableList,
  commonSchema,
  areaBSchema,
  areaCSchema,
  areaDSchema,
};
